var pdfStatus = (function () {
    'use strict';

    var container = document.getElementById('pdf-status');
    var downloadBtn = document.getElementById('downloadBtn');
    var polling = null;

    function init() {
        if (!container) return;

        var jobId = container.getAttribute('data-job-id');
        var statusUrl = '/declarationofconformity/pdf-status-api/' + jobId;

        function checkStatus() {
            fetch(statusUrl)
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {

                    if (data.ready) {

                        // Stop polling
                        if (polling) {
                            clearInterval(polling);
                        }

                        if (downloadBtn) {
                            downloadBtn.disabled = false;
                            downloadBtn.innerText = 'Download PDF';

                            downloadBtn.onclick = async function () {
                                try {
                                    downloadBtn.disabled = true;
                                    downloadBtn.innerText = 'Preparing PDF...';

                                    const response = await fetch(data.downloadUrl);

                                    if (response.status === 404) {
                                        window.location.href = '/declarationofconformity/pdfdownloadexpired';
                                        return;
                                    }

                                    const blob = await response.blob();
                                    const url = window.URL.createObjectURL(blob);

                                    const a = document.createElement("a");
                                    a.href = url;
                                    a.download = data.fileName;
                                    //document.body.appendChild(a);
                                    a.click();
                                    //a.remove();

                                    window.URL.revokeObjectURL(url);

                                    window.location.href = '/';
                                }
                                catch (err) {
                                    console.error(err);
                                    window.location.href = data.downloadUrl;
                                }
                                finally {
                                    downloadBtn.disabled = false;
                                    downloadBtn.innerText = 'Download PDF';
                                }
                            };
                        }
                    }
                })
                .catch(function (err) {
                    console.error('PDF status check failed', err);
                });
        }

        polling = setInterval(checkStatus, 2000);

        checkStatus();
    }

    return {
        init: init
    };

})();

pdfStatus.init();